import { render, staticRenderFns } from "./ArticleCol.vue?vue&type=template&id=c65a5d8c&scoped=true&"
import script from "./ArticleCol.vue?vue&type=script&lang=js&"
export * from "./ArticleCol.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCol.vue?vue&type=style&index=0&id=c65a5d8c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65a5d8c",
  null
  
)

export default component.exports